import { Skull } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgEditSkull1 = mkIcon(Skull);
